export enum FeedbackMessages {
    SIGNALR_CONNECTION_ERROR = 'signalr_connection_error',
    SIGNALR_CONFIGURATION_ERROR = 'signalr_configuration_error',
    COMMON_ERROR = 'common_error_message',
    COMMON_SUCCESS_UPDATE = 'Your_data_has_been_updated_successfully',
    COMMON_SUCCESS_CREATE = 'Your_data_has_been_created_successfully',
    COMMON_SUCCESS_DELETE = 'Your_data_has_been_deleted_successfully',
    COPIED = 'copied',
    ERROR_FETCHING = 'an_error_occurred_while_processing_your_request',
    ERROR_LOADING_INITIAL_NOTIFICATIONS = 'error_loading_initial_notifications',
    ERROR_LOADING_PROCESSES = 'error_loading_processes',
    ERROR_PROCESS_NOT_VISIBLE = 'error_process_not_visible',
    ERROR_RESOLVING_NOTIFICATION = 'error_resolving_notification',
    ERROR_OPENING_NOTIFICATION_HOTEL = 'error_opening_notification_hotel',
    ERROR_UNAUTHORIZED = 'default_unauthorized_error',
    WRONG_CREDENTIALS = 'the_data_entered_is_not_correct',
    WRONG_BOOKING_CODE = 'booking_code_does_not_exist',
    // connection requests related
    SUCCESSFUL_CONNECTION_REQUEST_SENT = 'connection_request_sent_successfully',
    SUCCESSFUL_CONNECTION_REQUEST_ACCEPTED = 'connection_request_accepted_successfully',
    SUCCESSFUL_CANCEL_REQUEST_SENT = 'cancel_request_sent_successfully',
    SUCCESSFUL_CONNECTION_REQUEST_REJECTED = 'connection_request_rejected_successfully',
    // zitoneo related
    ZITONEO_SUCCESSFUL_STATUS_CHANGE = 'zitoneo_status_changed_successfully',
    ZITONEO_NOT_MEMBER = 'zitoneo_not_member',
    SCRAPER_RESULTS_SCOPE_MISMATCH = 'scraper_results_scope_mismatch',
}
